export enum LoadStatus {
  None,
  Checking,
  NotFound,
  Found,
  Error,
}
